import { render, staticRenderFns } from "./AddCategoryRow.vue?vue&type=template&id=57aefe9e&"
import script from "./AddCategoryRow.vue?vue&type=script&lang=js&"
export * from "./AddCategoryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports